<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>总广告分析报表</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="searchleft">
                        <el-form :inline="true" :model="channel" class="demo-form-inline" @submit.native.prevent >
                            <el-form-item label="渠道">
                                <el-select v-model="searchform.channel" placeholder="请选择" style="width:150px">
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option label="facebook" value="facebook"></el-option>
                                    <el-option label="google" value="google"></el-option>
                                    <el-option label="tiktok" value="tiktok"></el-option>
                                    <el-option label="organic" value="organic"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="平台">
                                <el-input v-model="searchform.platform" :min="0" size="small" ></el-input>
                            </el-form-item>
                            <el-form-item label="时间">
                                <el-date-picker
                                    v-model="value1"
                                    type="daterange"
                                    size="small"
                                    @change="checkdata"
                                    range-separator="至"
                                    value-format="yyyy-MM-dd"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="download">下载报表</el-button>
                            </el-form-item>
                            <el-form-item label="更新时间：">
                                <div style="color:red">{{updatetime}}</div>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="top"></div>
                    <el-table :data="list" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="ads_channel" label="渠道"></el-table-column>
                        <el-table-column prop="campaign_id" label="广告id" width="160px"></el-table-column>
                        <el-table-column prop="campaign_name" label="广告名称" width="450px"></el-table-column>
                        <el-table-column prop="install_count" label="安装数"></el-table-column>
                        <el-table-column prop="register_count" label="注册数"></el-table-column>
                        <el-table-column prop="register_rate" label="注册率"></el-table-column>
                        <el-table-column prop="order_count" label="提交订单数"></el-table-column>
                        <el-table-column prop="order_rate" label="提交订单率"></el-table-column>
                        <el-table-column prop="pay_count" label="放款数"></el-table-column>
                        <el-table-column prop="pay_rate" label="放款率"></el-table-column>
                        <el-table-column prop="repay_count" label="还款数"></el-table-column>
                        <el-table-column prop="repay_rate" label="还款率"></el-table-column>
                        <el-table-column prop="score_min" label="最低分"></el-table-column>
                        <el-table-column prop="score_mean" label="平均分"></el-table-column>
                        <el-table-column prop="score_max" label="最高分"></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    phone: null,
                    userName: null,
                    email: null,
                    channel: null,
                },
                searchform: {
                    channel: null,
                    platform: null,
                },
                loading: false,
                showadd: false,
                phone:null,
                list: [],
                value1:null,
                downloadurl:null,
                updatetime:null,
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            //this.value1 = this.getNowTime()
            this.getList()
        },
        methods: {
            getNowTime() {
                const now = Date.now();
                const startDate = new Date(now - 7 * 86400000); // 7天前
                const endDate = new Date(now + 1 * 86400000);   // 1天后

                // 本地时间格式化函数
                const formatLocalDate = (date) => {
                    return [
                    date.getFullYear(),
                    String(date.getMonth() + 1).padStart(2, '0'),
                    String(date.getDate()).padStart(2, '0')
                    ].join('-');
                };
                return [formatLocalDate(startDate), formatLocalDate(endDate)];
            },
            download(){
                window.open(this.downloadurl, "_blank");
            },
            getList() {
                this.loading = true
                // if (this.value1 == null) {
                //     this.$message.error(this.$t('tel87'))
                //     return
                // }
                _api.get(apiurl.totalAdvert, {
                    channel: this.searchform.channel,
                    createTime: this.value1,
                    platform: this.searchform.platform,
                }).then(res => {
                    this.loading = false
                    const jsonObj = JSON.parse(res.data);
                    this.updatetime = jsonObj.update_time;
                    this.downloadurl = jsonObj.download_url;
                    this.list = jsonObj.data
                })
            },
            onSubmit() {
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>